<template>
  <div class="card-md" :style="{background: background}">
    <div class="card-md-caption">
      <div class="card-md-title">
        <h6>{{ title }}</h6>
      </div>
      <div class="card-md-price">
        <p>{{ price }}₸</p>
      </div>
      <div class="card-md-desc">
        <p v-html="desc"></p>
      </div>
      <button class="btn btn-success" @click="goToDetail(id)">
        <span>Толығырақ</span>
        <i class="icon chevron-right"></i>
      </button>
    </div>
    <div class="card-md-img">
      <img :src="img" alt="фото книги">
    </div>
  </div>
</template>

<script>
export default {
  name: "VCardMd",
  props: {
    background: String,
    title: String,
    price: Number,
    desc: String,
    img: String,
    id: Number,
  },
  emits: ['goToDetail'],
  methods: {
    goToDetail(id) {
      this.$router.push({ name: 'product', params: { id: id }})
    }
  }
}
</script>

<style scoped>

</style>